<template>
  <div class="merchants-shop template-detail-body">
    <div class="ccui-navigation">
      <el-button
        size="mini"
        type="primary-icon-medium"
        icon="icon-ccui-return"
        @click="handleBack"
        >返回</el-button
      >
      <div class="ccui-navigation-divider" />
      <!-- 面包屑 -->
      <el-breadcrumb
        class="ccui-navigation-crumbs-container"
        separator-class="el-icon-arrow-right"
      >
        <el-breadcrumb-item :to="{ path: '/index' }">{{
          $store.getters.getBreadcrumb("level1").name
        }}</el-breadcrumb-item>
        <el-breadcrumb-item
          :to="{
            path: '/expertManage/expertManages/perfectInformation/list'
          }"
          >专家信息维护</el-breadcrumb-item
        >
        <el-breadcrumb-item
          :to="{
            path:
              $route.query.type == 1
                ? '/expertManage/expertManages/manageNnitAdd/list'
                : '/expertManage/expertManages/outExpert/list'
          }"
          >{{
            $route.query.type == 1 ? "管理单位新增" : "退出专家库"
          }}</el-breadcrumb-item
        >

        <el-breadcrumb-item>
          <span>详情</span>
          <span class="ccui-curr-crumb ccui-ml-10"></span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!--主体部分-->
    <div class="detail-box3 ccui-clearfix">
      <div class="detail-info">
        <div v-if="true" class="ccui-app-container-detail">
          <div class="ccui-app-container-detail-body rel">
            <el-tabs
              v-model="activeName"
              class="el-tabs__customize dic-sub-tabs-style01"
            >
              <el-tab-pane label="管理单位信息" name="tab01">
                <el-form
                  label-width="180px"
                  class="ccui-form"
                  :model="formData"
                  ref="forms"
                >
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="当前管理单位：">
                        {{ formData.manageUnitShorts }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item
                        label="新增管理单位："
                        prop="manageUnitFullName"
                      >
                        {{ formData.manageUnitFullName }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </el-tab-pane>
              <el-tab-pane label="专家信息" name="tab02">
                <el-form
                  label-width="180px"
                  class="ccui-form"
                  :model="formData"
                  ref="form"
                >
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="专家姓名：" prop="expertName">
                        {{ formData.expertName }}
                      </el-form-item>
                    </el-col>

                    <el-col :span="12">
                      <el-form-item label="证件类型：" prop="certificateType">
                        {{ formData.certificateTypeStr }}
                      </el-form-item>
                    </el-col>

                    <el-col :span="12">
                      <el-form-item label="证件号码：" prop="idNumber">
                        {{ formData.idNumber }}
                      </el-form-item>
                    </el-col>

                    <el-col :span="12">
                      <el-form-item label="内外部专家：">
                        外部专家
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="擅长领域：" prop="expertField">
                        {{ formData.expertFieldStr }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="管理方向：" prop="manageDirection">
                        {{ formData.manageDirectionStr }}
                      </el-form-item>
                    </el-col>

                    <el-col :span="24">
                      <el-form-item label="专业特长：" prop="professionalStr">
                        {{ formData.professionalStr || "暂无" }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="是否省、部级专家：" prop="gradeFlag">
                        {{ formData.gradeFlagStr }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="专家性别：" prop="expertSex">
                        {{ formData.expertSexStr }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="出生年月：" prop="">
                        {{ formData.birthDay }}
                      </el-form-item>
                    </el-col>

                    <el-col :span="12">
                      <el-form-item label="毕业院校：" prop="">
                        {{ formData.graduateSchool }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="毕业年份：" prop="graduateYear">
                        {{ formData.graduateYear }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="学历：">
                        {{ formData.academicStr }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="专业：" prop="">
                        {{ formData.special }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="民族：" prop="">
                        {{ formData.nationStr }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="籍贯：" prop="">
                        {{ formData.nativePlace }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="职称：" prop="postTitle">
                        {{ formData.postTitleStr }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="职务：" prop="">
                        {{ formData.duty }}
                      </el-form-item>
                    </el-col>

                    <el-col :span="12">
                      <el-form-item label="手机：" prop="mobileNum">
                        {{ formData.mobileNum }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系电话：" prop="contactPhone">
                        {{ formData.contactPhone }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="电子邮件：" prop="email">
                        {{ formData.email }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="传真：" prop="fax">
                        {{ formData.fax }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="居住地：" prop="locationValue">
                        {{ formData.address }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="详细地址：" prop="">
                        {{ formData.detailedAddress }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="通讯地址：" prop="">
                        {{ formData.commAddr }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="邮政编码：" prop="postCode">
                        {{ formData.postCode }}
                      </el-form-item>
                    </el-col>

                    <!-- <el-col :span="12">
                      <el-form-item
                        label="管理单位："
                        prop="manageUnitFullName"
                      >
                        {{ formData.manageUnitName }}
                      </el-form-item>
                    </el-col> -->

                    <el-col :span="12">
                      <el-form-item label="专家状态：" prop="">
                        {{ formData.manageStatusStr }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item
                        label="工作经历："
                        class="remarkClass"
                        prop=""
                      >
                        {{ formData.workExperience }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item
                        label="主要业绩："
                        class="remarkClass"
                        prop=""
                      >
                        {{ formData.mainAchieve }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <!-- <el-row>
                    <el-col :span="24">
                      <el-form-item label="附件：" class="remarkClass" prop="">
                        <attachmentUpload
                          ref="attachmentUpload"
                          :fileData="fileData"
                        ></attachmentUpload>
                      </el-form-item>
                    </el-col>
                  </el-row> -->
                </el-form>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
    <!--底部功能按钮-->
    <el-bottom-guide>
      <ul class="ccui-bottom-button">
        <li>
          <el-button
            type="bottom"
            size="small"
            icon="icon-ccui-return"
            @click="handleBack"
            >返回</el-button
          >
        </li>
      </ul>
    </el-bottom-guide>

    <!--选择管理单位-->
    <chooseUnit
      ref="choosePurchaseInstitutionNameDialogVisible"
      :partyId="Number(partyId)"
      :orgId="String(orgID)"
      :isselectedData="purchaseInstitutionNameSelectedNode"
      :requestSeachParams="requestSeachParams"
      @chooseOrganizationalUnitTrueValue="
        choosePurchaseInstitutionNameTrueValue
      "
    >
    </chooseUnit>

    <!-- 选择专业特长 -->
    <ProfessionalCategorySingle
      ref="professionDialog"
      @getProfessions="getProfessions"
      :listSubconBaseSubjectList="professionList"
    ></ProfessionalCategorySingle>
  </div>
</template>

<script>
import chooseUnit from "@/app/sourceManage/components/chooseUnit";
import ProfessionalCategorySingle from "@/app/sourceManage/components/ProfessionalCategorySingle";
import {
  selectSubjectNewList,
  updateExternalExpert,
  qryAreaAddressLoginOUtCountry,
  getExternalExpertDetail,
  listDictByCode
} from "@/app/sourceManage/api/expert";

import validators from "@/basa/utils/validators";
import Cookies from "js-cookie";

export default {
  name: "perfectInformationEdit",
  components: {
    // attachmentUpload,
    chooseUnit,
    ProfessionalCategorySingle
  },
  data() {
    const idNumberValidator = (rule, value, callback) => {
      let regexp = "",
        message = "";
      if (this.formData.certificateType === "4") {
        // 身份证号
        regexp = /^1[45][0-9]{7}|G[0-9]{8}|P[0-9]{7}|S[0-9]{7,8}|D[0-9]+$/;
        message = "护照号码";
      } else {
        // 护照
        regexp = /^\d{6}(19|2\d)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)?$/;
        message = "身份证号码";
      }
      if (value) {
        if (value.match(regexp)) {
          callback();
        } else {
          callback(new Error("请输入正确的" + message));
        }
      } else {
        callback(new Error("请输入证件号码"));
      }
    };
    return {
      submitAssignmentList: [],
      requestSeachParams: {
        searchName: ""
      },
      purchaseInstitutionNameSelectedNode: [], //确认选择的采购人数据
      professionList: [],
      isShow: false,
      purchaseInstitutionNamePartyId: 100002, //单位采购的父级Id
      // 选择组织单位弹窗
      activeName: "tab01",
      manageDirection: [],
      formDatas: {
        manageDirection: []
      },
      formData: {
        expertId: "",
        idNumber: "",
        isNew: "外部专家",
        certificateType: "",
        expertField: "",
        postTitle: "",
        professional: [],
        professionalStr: [],
        manageDirection: [],
        expertSex: "",
        expertManageId: "",
        gradeFlag: null,
        manageStatus: "",
        manageStatusStr: "",
        email: "",
        free1: "",
        free2: "",
        workExtOid: "",
        manageExtOid: "",
        contactPhone: "",
        manageDeptId: "",
        manageDeptCode: "",
        manageDeptName: "",
        manageDeptShort: "",
        manageUnitId: "",
        manageUnitCode: "",
        manageUnitName: "",
        manageUnitShort: "",
        workUnitId: "",
        workUnitCode: "",
        workUnitName: "",
        workUnitShort: "",
        workUnitFullName: "",
        departmentId: "",
        departmentName: "",
        birthDay: "",
        graduateSchool: "",
        graduateYear: "",
        academicId: "",
        special: "",
        nation: "",
        nativePlace: "",
        duty: "",
        fax: "",
        locationValue: "",
        detailedAddress: "",
        commAddr: "",
        postCode: "",
        opUnitFullName: "",
        manageUnitFullName: "",
        workExperience: "",
        mainAchieve: "",
        mobileNum: ""
      },
      rules: {
        expertName: [
          { required: true, message: "请输入专家姓名", trigger: "blur" }
        ],
        certificateType: [
          { required: true, message: "请选择证件类型", trigger: "change" }
        ],
        idNumber: [{ validator: idNumberValidator, trigger: "blur" }],
        isNew: [{ required: true, message: "请输入", trigger: "blur" }],
        expertField: [
          { required: true, message: "请选择擅长领域", trigger: "change" }
        ],
        professionalStr: [
          { required: true, message: "请选择专业特长", trigger: "change" }
        ],
        manageDirection: [
          { required: true, message: "请选择管理方向", trigger: "change" }
        ],
        gradeFlag: [
          {
            required: true,
            message: "请选择是否省、部级专家",
            trigger: "change"
          }
        ],
        expertSex: [
          { required: true, message: "请选择专家性别", trigger: "change" }
        ],
        graduateYear: [
          { required: true, message: "请选择毕业年份", trigger: "change" }
        ],
        postTitle: [{ required: true, message: "请输入职称", trigger: "blur" }],
        workUnitId: [
          { required: true, message: "请输入工作单位", trigger: "blur" }
        ],
        mobileNum: [
          { required: true, message: "请输入手机号", trigger: "blur" }
          // { validator: validators.mobile, trigger: "blur" }
        ],
        email: [
          { required: true, message: "请输入电子邮件", trigger: "blur" },
          {
            validator: validators.email,
            message: "请输入正确格式的电子邮件",
            trigger: "blur"
          }
        ],
        contactPhone: [
          {
            validator: validators.mobileTel,
            message: "请输入正确的联系电话",
            trigger: "blur"
          }
        ],
        fax: [
          {
            validator: validators.fax,
            message: "请输入正确的传真",
            trigger: "blur"
          }
        ],
        postCode: [{ validator: validators.stamp, trigger: "blur" }],
        locationValue: [
          { required: true, message: "请选择居住地", trigger: "change" }
        ],
        manageDeptCode: [
          { required: true, message: "请选择管理部门", trigger: "change" }
        ],
        manageUnitFullName: [
          { required: true, message: "请选择编制单位", trigger: "change" }
        ],
        opUnitFullName: [
          { required: true, message: "请选择管理单位", trigger: "change" }
        ]
      },
      manageDirectionOptions: [], //管理方向
      certificateOptions: [],
      fieldOptions: [],
      postTitleOptions: [], //职称
      academicOptions: [], //学历
      nationOptions: [], //民族
      sexOptions: [], //性别
      manageDeptTreeProps: {
        label: "name",
        isLeaf: "isLeaf"
      },
      locationProps: {
        label: "addressName",
        value: "addressCode",
        lazy: true,
        checkStrictly: true,
        expandTrigger: "hover", // 鼠标滑过展开
        lazyLoad(node, resolve) {
          if (node.level === 0) {
            qryAreaAddressLoginOUtCountry({}).then(res => {
              if (res.data.code === "0") {
                resolve(res.data.data);
              }
            });
          } else {
            qryAreaAddressLoginOUtCountry({
              parentCode: node.data.addressCode
            }).then(res => {
              if (res.data.code === "0") {
                res.data.data.map(item => {
                  item.leaf = item.lastFlag === 1;
                });
                resolve(res.data.data);
              }
            });
          }
        }
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      workUnitTreeProps: {
        label: "name",
        children: "children",
        isLeaf: "isLeaf"
      },
      type: "",
      departmentOptions: [], //所属部门

      defaultKeys2: [],
      props2: {
        label: "name",
        children: "children",
        isLeaf: "isLeaf"
      },
      upExpertId: "",
      expertId: "",
      headers: {
        Authorization: Cookies.get("access_token") || "",
        APP_TOKEN: localStorage.appToken || ""
      },
      parentId: "",
      purchaseDepartmentNameSelectedNode: [],
      orgID: JSON.parse(sessionStorage.getItem("userDetal")).orgId,
      partyId: JSON.parse(sessionStorage.getItem("userDetal")).partyRelaId
    };
  },
  watch: {
    "formDatas.manageDirection": {
      handler(newVal, oldVal) {
        console.log(newVal, oldVal, "newVal,oldVal");
        if (newVal.length > 0) {
          newVal.includes("1") || newVal.includes("3")
            ? (this.isShow = true)
            : (this.isShow = false);
        } else {
          this.isShow = false;
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    // },
    getProfessionList(type) {
      selectSubjectNewList({ isSelectThreeLevel: "0" }).then(res => {
        if (res.data.code === "0") {
          this.professionList = res.data.data;
        }
      });
    },
    //选择管理单位
    choosePurchaseInstitutionName() {
      this.$refs[
        "choosePurchaseInstitutionNameDialogVisible"
      ].dialogVisible = true;
    },

    //确定选择编制单位
    choosePurchaseInstitutionNameTrueValue(data, orgTypes, orginName, node) {
      console.log(data, "sasasa");
      this.purchaseInstitutionNameSelectedNode = [data];
      this.$set(this.formData, "manageUnitName", data.name);
      this.$set(this.formData, "manageUnitCode", data.autoCode);
      this.$set(this.formData, "manageUnitExitOid", data.extOid);
      this.$set(this.formData, "manageUnitId", data.orgId);
      this.$set(this.formData, "manageUnitShort", data.abbrName);
      this.$set(this.formData, "manageUnitFullName", data.orgFullName);
      this.$refs[
        "choosePurchaseInstitutionNameDialogVisible"
      ].dialogVisible = false;
    },
    openTypeDialog() {
      this.$refs.professionDialog.centerDialogVisible2 = true;
    },
    getProfessions(keys, names) {
      this.$set(this.formData, "professional", keys);
      this.$set(this.formData, "professionalStr", names);
      // this.formData.packType = keys[0];
      // this.formData.packTypeName = names;
    },
    getDicData() {
      //证件类型
      listDictByCode({ code: "IDTYPE" }).then(res => {
        if (res.data.code === "0") {
          this.certificateOptions = res.data.data;
        }
      });
      //擅长领域
      listDictByCode({ code: "EXPERT_GOOD_FIELD_PACK" }).then(res => {
        if (res.data.code === "0") {
          this.fieldOptions = res.data.data;
        }
      });
      //管理方向
      listDictByCode({ code: "MANAGE_DIRECTION" }).then(res => {
        if (res.data.code === "0") {
          this.manageDirectionOptions = Object.freeze(res.data.data);
        }
      });
      //职称
      listDictByCode({ code: "POST_TITLE" }).then(res => {
        if (res.data.code === "0") {
          this.postTitleOptions = res.data.data;
        }
      });
      //学历
      listDictByCode({ code: "EXPERT_ACADEMIC" }).then(res => {
        if (res.data.code === "0") {
          this.academicOptions = res.data.data;
        }
      });
      //民族
      listDictByCode({ code: "BAS_NATION" }).then(res => {
        if (res.data.code === "0") {
          this.nationOptions = res.data.data;
        }
      });
      //性别
      listDictByCode({ code: "COMMON_SEX_STATUS" }).then(res => {
        if (res.data.code === "0") {
          this.sexOptions = res.data.data;
        }
      });
    },
    init() {
      let params = {
        isCurrent: 1,
        isTakeEffect: 0,
        isShowPageLoading: true
      };

      getExternalExpertDetail(params).then(res => {
        if (res.data.code === "0") {
          if (
            res.data.data.sscExpertManageUnitBO &&
            res.data.data.sscExpertManageUnitBO.length > 0
          ) {
            res.data.data.sscExpertManageUnitBO.forEach(item => {
              if (item.manageUnitId == this.$route.query.manageUnitId) {
                this.formData = Object.assign(
                  {},
                  res.data.data.expertDetailBO,
                  item
                );
              }
            });
          }
          if (this.formData.birthDay) {
            this.formData.birthDay = this.formData.birthDay.substr(0, 10);
          }
          this.formData.free1 = res.data.data.expertDetailBO.free1;
          this.formData.workUnitId = Number(this.formData.workUnitId);
          this.formDatas.manageDirection = this.formData.manageDirection;
          this.formData.locationValue = this.formData.location
            ? [
                this.formData.location,
                this.formData.city,
                this.formData.province,
                this.formData.county
              ]
            : [];
          this.$refs["cas"].inputValue = this.formData.location
            ? `${this.formData.locationStr} / ${this.formData.provinceStr} / ${this.formData.cityStr} / ${this.formData.countyStr}`
            : "";

          if (this.type === "2" || this.type === "3") {
            this.formData.manageStatus = this.$route.query.manageStatus;
            this.formData.manageStatusStr = this.$route.query.manageStatusStr;
          }

          // if (this.type == 3) {
          //   this.expertId = res.data.data.sscExpertManageUnitBO.expertId;
          //   this.upExpertId = res.data.data.sscExpertManageUnitBO.upExpertId;
          //   queryExpertCurrentBaseInfo({
          //     staffNo: res.data.data.sscExpertManageUnitBO.staffNo,
          //   }).then((result) => {
          //     console.log(result.data.data.expertDetailBO, "result");
          //     if (result.data.data.expertDetailBO) {
          //       let obj = Object.assign(
          //         {},
          //         res.data.data.expertDetailBO,
          //         result.data.data.expertDetailBO
          //       );
          //       this.fileData = obj.fileinfoList || [];

          //       this.formData = Object.assign(
          //         {},
          //         obj,
          //         res.data.data.sscExpertManageUnitBO
          //       );
          //       this.formData.free1 = res.data.data.expertDetailBO.free1;
          //       this.formData.mobileNum = this.formData.mobile;
          //       this.formData.workUnitId = Number(this.formData.workUnitId);
          //       this.formDatas.manageDirection = this.formData.manageDirection;
          //       this.formData.locationValue = this.formData.location
          //         ? [
          //             this.formData.location,
          //             this.formData.city,
          //             this.formData.province,
          //             this.formData.county,
          //           ]
          //         : [];
          //       this.$refs["cas"].inputValue = this.formData.address;
          //     }
          //   });
          // }
        }
      });
    },

    clearManage() {
      this.purchaseDepartmentNameSelectedNode = [];
      this.formData.manageDeptId = "";
      this.formData.manageDeptCode = "";
      this.formData.manageDeptName = "";
      this.formData.manageDeptShort = "";
      this.formData.manageUnitId = "";
      this.formData.manageUnitCode = "";
      this.formData.manageUnitName = "";
      this.formData.manageUnitShort = "";
    },

    expertChange() {
      if (this.formData.staffNo) {
        updateExternalExpert({
          staffNo: this.formData.staffNo,
          operationType: 3
        }).then(res => {
          if (res) {
            if (res.data.message == "此专家已存在专家网络中，请重新选择专家") {
              this.formData.mobileNum = "";
              this.formData.contactPhone = "";
              this.formData.workUnitName = "";
              this.formData.workExtOid = "";
              this.formData.workUnitId = "";
              this.formData.departmentName = "";
              this.formData.email = "";
              this.formData.expertSex = "";
              this.formData.expertName = "";
              this.formData.staffNo = "";
            }
          }
        });
      }
    },
    save() {
      this.check(1);
    },
    takeEffect() {
      let _this = this;
      this.$refs["form"].validate(valid => {
        if (valid) {
          _this.$refs["formOther"].validate(isValid => {
            if (isValid) {
              this.check(4); //提交审批
            }
          });
        }
      });
    },
    check(type) {
      console.log(this.formData, "this.formData.professional");
      let _this = this;
      this.$refs["form"].validate(valid => {
        if (valid) {
          _this.$refs["formOther"].validate(isValid => {
            if (isValid) {
              let params = {
                ..._this.formData,
                sscExpertManageUnitBO: {
                  manageUnitId: _this.formData.manageUnitId,
                  manageUnitCode: _this.formData.manageUnitCode,
                  manageUnitName: _this.formData.manageUnitName,
                  manageUnitExitOid: _this.formData.manageUnitExitOid,
                  manageUnitShort: _this.formData.manageUnitShort,
                  manageUnitFullName: _this.formData.manageUnitFullName
                }
              };
              if (_this.isShow) {
                params.professional = _this.formData.professional;
              } else {
                params.professional = [];
              }
              params.operationType = type;
              console.log(params, "params");
              updateExternalExpert(params).then(res => {
                let message = type === 1 ? "保存成功！" : "提交审批成功！";
                if (res.data.code === "0") {
                  _this.$message({
                    message: message,
                    type: "success",
                    duration: 3000,
                    ccuiCustom: true,
                    showClose: true,
                    offset: document.body.clientHeight / 2 - 21
                  });
                  _this.$router.go(-1);
                }
              });
            }
          });
        }
      });
    },
    //选择居住地
    handleChange(data) {
      if (data) {
        let pathLabels = this.$refs["cas"].getCheckedNodes()[0].pathLabels;
        this.formData.location = data[0] ? data[0] : "";
        this.formData.province = data[1] ? data[1] : "";
        this.formData.city = data[2] ? data[2] : "";
        this.formData.county = data[3] ? data[3] : "";
        this.formData.address = `${pathLabels[0] ? pathLabels[0] : ""}${
          pathLabels[1] ? pathLabels[1] : ""
        }${pathLabels[2] ? pathLabels[2] : ""}${
          pathLabels[3] ? pathLabels[3] : ""
        }`;
      }
    },

    changeDepartment(data) {
      this.formData.departmentId = data.deptId;
      this.formData.departmentName = data.deptName;
    },
    handleBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped lang="scss">
/deep/ .el-radio:last-child {
  margin-right: 30px;
}
.rel {
  position: relative;
  .star {
    position: absolute;
    left: 90px;
    line-height: 30px;
  }
}
/deep/ .selected_button {
  width: 46px;
  margin-left: 10px;
  padding: 0 9px;
}
</style>
